export default __webpack_public_path__ + "assembly481a683.png";